import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { NotificacionService } from 'src/app/services/service.index';
declare const toastr: any;
declare var jQuery: any;

@Component({
  selector: 'app-avisos',
  templateUrl: './avisos.component.html',
  styleUrls: []
})
export class AvisosComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  dataResourceFU: any[];
  dataSourceGrupos: any[];
  model: any = {
    id: 0,
    titulo_aviso: '',
    detalle_aviso: '',
    fecha_aviso: '',
    tipo_aviso: '',
    grupo_id: 0,
    aviso: '',
    con_documento_adjunto: false,
    enviar_correo: false
  };
  popupVisibleVer: boolean = false;
  notificacionId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleInactivar: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;
  tipos: any[] = [{ id: 1, descripcion: 'ANUNCIO' }, { id: 2, descripcion: 'MENSAJE' }];
  rol: number = 0;
  id_user: number = 0;
  file: File = null;
  maxFileSize = 2097152;
  typeFiles = ['application/pdf', 'image/jpeg', 'image/png', 'text/csv', 'text/xlsx', 'text/xls', '.xls', '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

  constructor(private _fs: NotificacionService) {
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.id_user = u.id;
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getAvisos();

  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { titulo_aviso: false, detalle_aviso: false, fecha_aviso: false, tipo_aviso: false, grupo_id: false, aviso: false, con_documento_adjunto: false };
  }

  getAvisos() {
    if ((this.rol == 23) || (this.rol == 15)) {
      this._fs.getNotificaciones().subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataResourceFU = result.data;
          } else {
            this.dataResourceFU = [];
          }
        },
        error => {
          console.log('Error', error);
        });
    }
    else {
      this._fs.getNotificacionesUsuario(this.id_user).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataResourceFU = result.data;
          } else {
            this.dataResourceFU = [];
          }
        },
        error => {
          console.log('Error', error);
        });
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  getGrupos() {
    this._fs.getGrupos().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataSourceGrupos = result.data;

        }
        else { this.dataSourceGrupos = []; }
      },
      (error) => { console.log('Error', error); });
  }


  showModalAdd() {
    this.clearErrors();
    this.getGrupos();
    this.model.id = 0;
    this.model.titulo_aviso = '';
    this.model.detalle_aviso = '';
    this.model.fecha_aviso = '';
    this.model.grupo_id = 0;
    this.model.aviso = '';
    this.popupVisibleAdd = true;
    this.file = null;
    this.model.enviar_correo = false;
    jQuery("#file").val('');
    this.model.file = '';
  }

  getGrupo(e: any) {
    this.model.grupo_id = e.value;
  }

  showModalEdit(data: any) {
    this.getGrupos();

    this.clearErrors();
    this.model.id = data.id;
    this.model.titulo_aviso = data.titulo_aviso;
    this.model.detalle_aviso = data.detalle_aviso;
    this.model.fecha_aviso = data.fecha_aviso;
    this.model.grupo_id = data.grupo_id;
    this.model.aviso = data.aviso;
    this.state_toogle = true;
    this.model.tipo_aviso = data.tipo_aviso;
    this.popupVisibleAdd = true;
  }

  concatSelector() {
    this.model.selector = this.model.codigo + ' - ' + this.model.sigla
  }


  saveAviso() {
    this.hasError = { titulo_aviso: false, detalle_aviso: false, fecha_aviso: false, tipo_aviso: false, grupo_id: false, aviso: false, con_documento_adjunto: false };

    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._fs.postAviso(this.model, this.file).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getAvisos();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._fs.putAviso(this.model, this.file).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getAvisos();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.notificacionId = id;
    this.popupVisibleDel = true;
  }

  deleteNotificacion() {
    this._fs.deleteAviso(this.notificacionId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getAvisos();
          this.popupVisibleDel = false;
          toastr.success('Proceso realizado correctamente.');
        } else {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.titulo_aviso, 'text')) {
      this.hasError.titulo_aviso = true; res = false;
    }
    if (!UtilHelper.validator(data.detalle_aviso, 'text')) {
      this.hasError.detalle_aviso = true; res = false;
    }
    if (!UtilHelper.validator(data.tipo_aviso, 'text')) {
      this.hasError.tipo_aviso = true; res = false;
    }
    if (!UtilHelper.validator(data.grupo_id, 'integer')) {
      this.hasError.grupo_id = true; res = false;
    }
    return res;
  }

  showModalInactivar(id: number) {
    this.notificacionId = id;
    this.popupVisibleInactivar = true;
  }

  inactivarNotificacion() {
    this._fs.inactivarNotificacion(this.notificacionId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getAvisos();
          this.popupVisibleInactivar = false;
          toastr.success('Proceso realizado correctamente.');
        } else {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    if (this.file != null) {
      this.model.con_documento_adjunto = true;
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG, PNG, DOC, DOCX, XLS, XLSX.');
      }
    }
  }

  showModalVer(data: any) {
    this.getGrupos();
    this.model.id = data.id;
    this.model.titulo_aviso = data.titulo_aviso;
    this.model.detalle_aviso = data.detalle_aviso;
    this.model.fecha_aviso = data.fecha_aviso;
    this.model.grupo_id = data.grupo_id;
    this.model.aviso = data.aviso;
    this.model.revisado = data.revisado;
    this.state_toogle = true;
    this.model.tipo_aviso = data.tipo_aviso;
    this.popupVisibleVer = true;
    this.model.documento_adjunto = data.documento_adjunto;

  }

  cambiarEstadoRevisado() {

    this._fs.cambiarEstadoRevisado(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getAvisos();
          this.popupVisibleVer = false;
          toastr.success(result.data);
        } else {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });


  }


}
